@if (mainFilename$ | async; as mainFilename) {
  <thh-pferd-angebot
    *axLazyElement="'thh-pferd-angebot/' + mainFilename"
    [dispatcher]="globalEventDispatcher"></thh-pferd-angebot>
}
